import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {DataTablesResponse} from "../models/dataTables-response";
import {webServiceConfig} from "../config/web-service.config";
import {map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class BrandService {

    constructor(private http: HttpClient) { }

    getDatatable(dataTablesParameters): Observable<any> {
        return this.http.post<DataTablesResponse>(`${webServiceConfig.webServiceUrl}brands/datatable`, dataTablesParameters, {})
            .pipe(map(response => {
                return response;
            }));
    }

    getAll(): Observable<any> {
        return this.http.get(`${webServiceConfig.webServiceUrl}brands`).pipe(map(response => {
            return response;
        }));
    }

    getTypeProducts(brandId: any): Observable<any> {
        return this.http.get(`${webServiceConfig.webServiceUrl}brands/type-products/${brandId}`).pipe(map(response => {
            return response;
        }));
    }

    getById(brandId: number): Observable<any> {
        return this.http.get(`${webServiceConfig.webServiceUrl}brands/${brandId}`).pipe(map(response => {
            return response;
        }));
    }

    store(brand: any): Observable<any> {
        return this.http.post(`${webServiceConfig.webServiceUrl}brands`, brand)
            .pipe(map(response => {
                return response;
            }));
    }

    update(brand: any): Observable<any> {
        return this.http.put(`${webServiceConfig.webServiceUrl}brands/${brand.id}`, brand)
            .pipe(map(response => {
                return response;
            }));
    }

    delete(id: number): Observable<any> {
        return this.http.delete(`${webServiceConfig.webServiceUrl}brands/${id}`)
            .pipe(map(response => {
                return response;
            }));
    }
}
